import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Typography } from '@material-ui/core';
import { VERSION_CONFIG } from 'version.js';

const WhiteTextTypography = withStyles({
  root: {
    color: "#FFFFFF",    
  }
})(Typography);


const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    // backgroundColor: "#F4623A",
    backgroundColor: theme.palette.siren_symbol.main
  }
}));


const Topbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      // color="primary"
      // position="fixed"
    >
      <Toolbar>
        {/* <RouterLink to="/">
          <img
            alt="Logo"
            src="/images/logo_white.png"
            width="160px"
          />
        </RouterLink> */}
        <div style={{ paddingLeft: "30px", display: 'flex', alignItems: 'top'}}>
          <WhiteTextTypography variant="h4">
            SirenCare Dashboard
          </WhiteTextTypography>

          <div style={{ paddingLeft: "5px" }}>
            <WhiteTextTypography variant="caption">
              ver:{VERSION_CONFIG.RELEASE_NO}
            </WhiteTextTypography>
          </div>
        </div>


      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string
};

export default Topbar;
